import { useState, useEffect } from "react";

/**
 * Nos dice si la pestaña del navegador es la principal
 * (si es la que tiene abierta el usuario)
 * @returns {bool}
 */

const useIsVisible = () => {
  const [isVisible, setIsVisible] = useState(document.visibilityState === "visible");

  useEffect(() => {
    const handleVisibilityChange = () => {
      setIsVisible(document.visibilityState === "visible");
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Limpieza del evento cuando el componente se desmonta
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return isVisible;
};

export default useIsVisible;
